import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    file: {
      type: Object,
    },
    type: String,
    alwaysShow: Boolean,
  },
  data() {
    return {
      tags: [],
      addingTag: false,
      showTags: false,
    };
  },
  created() {
    if (this.file) {
      this.tags = this.file.tags ? this.file.tags : [];
    }

    EventBus.$on(`tag-holder--delete`, (data) => {
      this.removeTagFromFile(data.id);
    });
  },
  methods: {
    removeTagFromFile(id) {
      const formData = new FormData();
      formData.append("tag", id);

      this.$axios.post(baseUrl + "/tagdelete", formData).then((r) => {
        this.tags = this.tags.filter((tag) => {
          return tag.id !== id;
        });
      });
    },

    addTag() {
      if (this.addingTag) {
        //get form data
        const formData = new FormData(this.$refs.newTag);

        //is already adding tag
        if (formData.get("tagname") !== "") {
          //add tag
          this.setAddingTag(false, false);

          formData.append("file", this.file.id);
          formData.append("myspace", this.file.mySpace);

          this.$axios.post(baseUrl + "/tagadd", formData).then((r) => {
            if (!this.file.tags) {
              this.file.tags = [];
            }

            this.file.tags.push(r.data);
            this.tags.push(r.data);
            this.showTags = true;
          });
        }
      } else {
        //not adding tag yet
        this.setAddingTag(false, true);
      }
    },
    toggleShowTags() {
      this.showTags = !this.showTags;
    },
    setAddingTag(e, status) {
      if (e) {
        e.preventDefault();
      }

      this.addingTag = status;
    },
  },
  watch: {
    file() {
      if (this.file) {
        this.tags = this.file.tags ? this.file.tags : [];
      }
    },
  },
};
